import { ArrowUpRight, CheckCircle, Clock, PlayCircle } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export function MetricGrid({ items, testPrefix }) {
  return (
    <section className="metric-grid" aria-label="Key metrics" data-testid={`${testPrefix}-metrics`}>
      {items.map((item) => (
        <article className="metric-card" key={item.label} data-testid={`${testPrefix}-${item.key}-metric`}>
          <span>{item.label}</span>
          <strong>{item.value}</strong>
          <small>{item.hint}</small>
        </article>
      ))}
    </section>
  );
}

export function CourseCard({ course, actionLabel = "Open course", testPrefix }) {
  const progress = course.progress ?? 0;
  return (
    <article className="course-card" data-testid={`${testPrefix}-${course.id}-card`}>
      <div className="course-card-topline">
        <span>{course.category}</span>
        <div className="course-card-meta">
          {course.status && (
            <span
              className="course-publication-status"
              data-testid={`${testPrefix}-${course.id}-status`}
            >
              {course.status}
            </span>
          )}
          <span>{course.duration}</span>
        </div>
      </div>
      <h3 data-testid={`${testPrefix}-${course.id}-title`}>{course.title}</h3>
      <p>{course.description}</p>
      <div className="course-detail-line">
        <Clock aria-hidden="true" size={17} />
        <span>{course.trainer_name}</span>
      </div>
      {typeof course.progress === "number" && (
        <div className="progress-block" data-testid={`${testPrefix}-${course.id}-progress`}>
          <div className="progress-label"><span>Progress</span><strong>{progress}%</strong></div>
          <div className="progress-track"><span style={{ width: `${progress}%` }} /></div>
        </div>
      )}
      <Link className="course-open-link" to={`/learner/course/${course.id}`} data-testid={`${testPrefix}-${course.id}-open-link`}>
        {progress > 0 ? <PlayCircle aria-hidden="true" size={20} /> : <ArrowUpRight aria-hidden="true" size={20} />}
        {actionLabel}
      </Link>
    </article>
  );
}

export function LoadingState({ label }) {
  return <div className="loading-state" data-testid="loading-state"><span /><p>{label}</p></div>;
}

export function StatusPill({ children, positive = false }) {
  return (
    <span className={`status-pill ${positive ? "status-positive" : ""}`} data-testid={`status-${String(children).toLowerCase().replaceAll(" ", "-")}`}>
      {positive && <CheckCircle aria-hidden="true" size={16} weight="fill" />}
      {children}
    </span>
  );
}